<template>
    <transition name="slide">
        <div class="modal fade" tabindex="-1" role="dialog" :class="onfilter ? 'show' : 'show'" :style="onfilter ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4">
                            <i class="bi bi-funnel"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">Filtro</h5>
                            <small class="d-block text-xs text-muted">Aplica los filtros para obtener la información que necesites.</small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="vstack gap-3">
                            <div>
                                <div class="row">
                                    <div class="col-md-6 pl-0 pr-0 pr-2">
                                        <small class="input-title">Desde</small>
                                        <v-menu v-model="menu_start"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field 
                                                    :value="filter.start_date" 
                                                    v-bind="attrs" 
                                                    v-on="on" 
                                                    hide-details
                                                    dense
                                                    readonly 
                                                    clearable
                                                    class="form-control form-control-sm" 
                                                    @click:clear="filter.start_date = ''">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker 
                                                v-model="filter.start_date" 
                                                no-title 
                                                scrollable
                                                @input="menu_start = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                    <div class="col-md-6 pl-0 pr-0">
                                        <small class="input-title">Hasta</small>
                                        <v-menu v-model="menu_end"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field 
                                                    :value="filter.end_date" 
                                                    v-bind="attrs" 
                                                    v-on="on" 
                                                    hide-details
                                                    dense
                                                    readonly 
                                                    clearable
                                                    class="form-control form-control-sm" 
                                                    @click:clear="filter.end_date = ''">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker 
                                                v-model="filter.end_date" 
                                                no-title 
                                                scrollable
                                                @input="menu_end = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                            </div>
                            <div v-if="String(exclude.find((e) => e == 'state_id')) == 'undefined'">
                                <small class="input-title">Estado</small>
                                <v-select v-model="filter.state_id" :items="states" item-value="id"
                                    hide-details clearable
                                    class="form-control form-control-sm">
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-h btn-primary px-3" @click="$emit('onfilter')">Aplicar</button>
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: {
        onfilter: {
            type: Boolean,
        }, 
        filter: {
            type: Object,
        },
        exclude: {
            type: Array,
            default: []
        }
    },
    data(){
        return{
            menu_start: false,
            menu_end: false,
            states: [
                { text: 'Abierta', id: 25 },
                { text: 'Entregada a chofer', id: 26 },
                { text: 'Cerrada', id: 27 },
            ],
        }
    },
}
</script>